module.exports = function() {
  return new Worker(__webpack_public_path__ + "b4efd2a0322621212615.worker.js");
};